import Icon from "@material-ui/icons/SyncDisabled";
import DueRenewalStudentList from "./DueRenewalStudentList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "studentRenewals",
  list: DueRenewalStudentList,
  icon: Icon,
};
